export default "__VITE_ASSET__3601131b__"